export const downloadFile = (file: { file: File | { type: string; name: string; url?: string } }) => {
  const fileName = file.file instanceof File ? file.file.name : file.file.name;

  if (file.file instanceof File) {
    // For File objects, create a blob URL
    const url = URL.createObjectURL(file.file);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } else if ('url' in file.file && file.file.url) {
    // For FileMetadata objects, use the URL directly
    const link = document.createElement('a');
    link.href = file.file.url;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const checkIsImageFile = (file: { file: File | { type: string; name: string } }) => {
  const fileType = file.file instanceof File ? file.file.type : file.file.type;
  const fileName = file.file instanceof File ? file.file.name : file.file.name;

  return fileType.startsWith('image/') || fileName.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i);
};
